module.exports = __webpack_public_path__ + "assets/svg/Icons/32/task-blue-2e4bd2.svg";